import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsUserLinkedCustomObjectTypes = "/data_objects/user_linked_data_object_types";

export const customObjectsUserLinkedCustomObjectTypesCacheKeys: AllRouteEndpoints[] = [
  "/data_objects/user_linked_data_object_types",
];
